
import { Vue, Component } from 'vue-property-decorator';

const Props = Vue.extend({
  props: {
    text: { type: String, default: '保密信息' },
    options: {
      type: Object,
      default: () => ({
        color: 'rgba(64,64,64,0.3)',
        // color: '#ccc',
        fontSize: 24,
        zIndex: 9999,
      }),
    },
  },
});

@Component
export default class Watermark extends Props {
  private observer!: MutationObserver;
  private watermarkElement!: HTMLDivElement;

  mounted() {
    this.initWatermark();
    this.observeChanges();
  }

  beforeDestroy() {
    this.observer?.disconnect();
  }

  private initWatermark(): void {
    const wrapper = this.$refs.watermarkWrapper as HTMLElement;
    this.watermarkElement = this.createWatermarkElement();
    wrapper.appendChild(this.watermarkElement);
  }

  private createWatermarkElement(): HTMLDivElement {
    const div: any = document.createElement('div');
    div.style.pointerEvents = 'none';
    div.style.position = 'absolute';
    div.style.zIndex = this.options.zIndex.toString();
    div.style.backgroundImage = `url("${this.generateWatermark()}")`;
    div.style.inset = '0';
    return div;
  }

  private generateWatermark(): string {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;

    // 计算文字宽度
    ctx.font = `${this.options.fontSize}px Arial`; // 设置字体大小
    const textWidth = ctx.measureText(this.text).width; // 计算文字宽度

    // 动态设置画布尺寸
    canvas.width = textWidth * 1.5; // 设置画布宽度
    canvas.height = this.options.fontSize * 6; // 设置画布高度

    // 绘制文字
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((-25 * Math.PI) / 180);
    ctx.fillStyle = this.options.color;
    ctx.fillText(this.text, -textWidth / 2, 0);

    return canvas.toDataURL('image/png');
  }

  private observeChanges(): void {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        if (!document.contains(this.watermarkElement)) {
          this.initWatermark(); // 水印被删除时重新创建
        }
      });
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}
